module.exports = __webpack_public_path__ + "static/media/BoxPlotQ6_3.19f08198.svg";